document.addEventListener('DOMContentLoaded', function() {
  /**
   * Custom select field for newsletter
   */
  const addCustomNewsletterFieldsAsTags = () => {
    const newsletterTagFields = [...document.querySelectorAll('[name="contact[tags]"]')];

    newsletterTagFields.forEach(tagField => {
      const form = tagField.closest('form');
      const customFields = [...form.querySelectorAll('[name*="custom_field"]')];

      customFields.forEach(field => {
        if (field.type === 'hidden') {
          let tags = tagField.value.split(',');
          tags.push(`${field.name}=${field.value}`);
          tagField.value = tags.join(',');
        } else {
          field.addEventListener('change', debounce((e) => {
            const fieldName = e.target.name;
            const fieldValue = e.target.value;
  
            let tags = tagField.value.split(',');
            const existingTagIndex = tags.findIndex(tag => tag.startsWith(`${fieldName}=`));
  
            if (existingTagIndex !== -1) {
              tags[existingTagIndex] = `${fieldName}=${fieldValue}`;
            } else {
              tags.push(`${fieldName}=${fieldValue}`);
            }
            
            tagField.value = tags.join(',');
          }, 300));
        }
      });
    });
  }

  addCustomNewsletterFieldsAsTags();
});